(function() {
    'use strict';

    angular
        .module('atheer')
        .config(function (localStorageServiceProvider) {
            localStorageServiceProvider.setPrefix('atheer');
        });
})();
